import { resolveMediaUrl } from '@/services/api-client';
import { cn } from '@/lib/utils';

function userInitials(name: string) {
  return name
    .split(/\s+/)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

type PainelUserAvatarProps = {
  name: string;
  avatarUrl?: string | null;
  large?: boolean;
  className?: string;
};

export function PainelUserAvatar({ name, avatarUrl, large, className }: PainelUserAvatarProps) {
  const resolvedUrl = resolveMediaUrl(avatarUrl);
  const sizeClass = large ? 'h-[4.5rem] w-[4.5rem] text-2xl' : 'h-10 w-10 text-sm';

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-2xl font-poppins font-bold text-sky-50 ring-1 ring-sky-400/40',
        'bg-gradient-to-br from-sky-500/30 to-indigo-700/20',
        large && 'shadow-[0_0_48px_-12px_rgba(56,189,248,0.45)]',
        sizeClass,
        className
      )}
    >
      {resolvedUrl ? (
        <img src={resolvedUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        userInitials(name)
      )}
    </span>
  );
}
